class Exception {
  constructor(message) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Error";
    this.message = void 0;
    this.name = void 0;
    this.message = message;
    this.name = name;
  }
}
export { Exception };